var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-confirmation-container" },
    [
      _vm.showMap()
        ? _c(
            "div",
            { staticClass: "map-wrapper" },
            [
              _c("BaseMap", {
                attrs: {
                  zoom: 12,
                  storeLocation: _vm.orderMap.origin,
                  directions: _vm.resolveMapDirections(),
                  height: _vm.getMapHeight
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.appLoaded
        ? _c("div", { staticClass: "map-wrapper" }, [_c("BaseLoader")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.fromCheckout
        ? _c("div", { staticClass: "center-message vertical-margins" }, [
            _c("p", [_vm._v("Awesome!")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Order #" + _vm._s(_vm.displayOrderId) + " placed")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isGuestLogin
        ? _c("div", { staticClass: "has-center-text vertical-margins" }, [
            _c("p", [
              _vm._v("Sign in to track your next order from any device:")
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.handleSignUpLink($event)
                      }
                    }
                  },
                  [_vm._v("Sign In or Sign Up")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.fromCheckout
        ? _c("div", { staticClass: "center-message vertical-margins" }, [
            _c("p", [
              _vm._v("Your Recent Order #" + _vm._s(_vm.displayOrderId))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "has-center-text vertical-margins" }, [
        _c("p", { staticClass: "margin-80" }, [
          _c("strong", [_vm._v(_vm._s(_vm.displayServiceTypeUsed()))]),
          _vm._v(" for "),
          _c("strong", [_vm._v(_vm._s(_vm.displayPromiseTime()))])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "margin-80" }, [
          _vm._v(_vm._s(_vm.useVerb) + " "),
          _c("strong", [_vm._v(_vm._s(_vm.getOrderDestination))])
        ])
      ]),
      _vm._v(" "),
      _vm.hasPhone
        ? _c("div", { staticClass: "has-center-text vertical-margins" }, [
            _vm._v(
              "\n\t\tQuestions? Call us at " +
                _vm._s(_vm.displayStorePhone) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tracker-header has-center-text" },
        [
          _c("BaseIcon", {
            attrs: {
              icon: "radar",
              editStroke: false,
              isCustom: true,
              size: "lg"
            }
          }),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.trackerName))])
        ],
        1
      ),
      _vm._v(" "),
      _vm.fromCheckout ? _c("order-tracker-container") : _vm._e(),
      _vm._v(" "),
      _vm.fromCheckout
        ? _c(
            "BaseDecorator",
            { staticClass: "reciept-background", attrs: { name: "frills" } },
            [
              [
                _c("div", { staticClass: "order-items" }, [_c("item-list")], 1),
                _vm._v(" "),
                _c("BaseActions", {
                  attrs: { actions: _vm.orderConfirmationActions() }
                }),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "fade-down", mode: "out-in" } },
                  [
                    _vm.showRecieptDetails
                      ? _c(
                          "div",
                          [
                            _c("receipt-info", {
                              attrs: { totals: _vm.getTotals }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "back-to-store full-width has-center-text" },
                  [
                    _c("a", { on: { click: _vm._navigateToHome } }, [
                      _vm._v("Back to home")
                    ])
                  ]
                )
              ]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b6d215a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b6d215a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order-confirmation/OrderConfirmationMobile.vue
// module id = null
// module chunks = 